/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react';
import { ThemeProvider } from "@mui/material/styles";
import Header from "../layout/Header/Header";
import { StepperBg, theme } from "../../src/components/Styles/StepsStyle";
import Style from "../../src/components/Styles/CssModulesGlobal.module.scss";
import { Box, Typography } from "@mui/material";

const TypographyCSS = {
    fontSize: 24,
    fontWeight: 600,
    color: "#1468A2",
    lineHeightt: "36px",
    marginBottom: "16px",
}
function Fallback() {

    return (
        <ThemeProvider theme={theme}>
            <Header isOnboarding={true} />
            <StepperBg>
                <Box className={Style.stepperMenu}>
                    <Typography sx={TypographyCSS}>
                        Permission denied.
                    </Typography>
                </Box>
            </StepperBg>
        </ThemeProvider>
    )
}

export default Fallback;